import { useEffect } from 'react';

export default function Login() {
  useEffect(() => {
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.replace(`/auth/login?return_to=${returnUrl}`);
  }, []);
  return <div role="status" aria-live="polite" style={{ padding: 12 }}>Redirecting to sign-in…</div>;
}


